import { render } from "./NosotrosComponent.vue?vue&type=template&id=673e262e"
import script from "./NosotrosComponent.vue?vue&type=script&lang=js"
export * from "./NosotrosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__